import React from "react";
import PortalCard from "./PortalCard";
import useContinueReading from "../../hooks/useContinueReading";
import { PortalButton } from "./PortalButton";

export default function ContinueReadingWidget() {
  const { items, loading } = useContinueReading();

  if (loading) {
    return (
      <PortalCard
        title="Continue Reading"
        subtitle="Loading your in-progress issues..."
        style={{ minHeight: "220px" }}
      >
        <p className="portal-muted">Checking your reading progress…</p>
      </PortalCard>
    );
  }

if (!items.length) {
  return (
    <PortalCard
      title="Continue Reading"
      subtitle="Pick up where you left off."
    >
      <div className="portal-stack">

        <p className="portal-muted" style={{ margin: 0 }}>
          Start flipping through our collection of Earth's Coolest comics and we'll save your progress right here.
        </p>

        <PortalButton onClick={() => (window.location.href = "/reader")}>
          Start Reading
        </PortalButton>
      </div>
    </PortalCard>
  );
}

  return (
    <PortalCard
      title="Continue Reading"
      subtitle="Pick up where you left off."
      style={{ minHeight: "unset" }}
    >
      <div className="continue-reading-strip">
        {items.map((item) => (
          <a
            key={item.issueId}
            href={item.href}
            className="continue-reading-tile"
          >
            <div className="continue-reading-tile__thumbWrap">
              {item.thumbnailURL ? (
                <img
                  src={item.thumbnailURL}
                  alt={item.issueTitle}
                  className="continue-reading-tile__thumb"
                />
              ) : (
                <div className="continue-reading-tile__thumbPlaceholder">
                  Cover
                </div>
              )}
            </div>

            <div className="continue-reading-tile__body">
              <div className="continue-reading-tile__text">
                <p className="continue-reading-tile__title">
                  {item.issueTitle || "Issue"}
                </p>

                <p className="continue-reading-tile__series">
                  {item.seriesTitle || "Series"}
                </p>

                <p className="continue-reading-tile__meta">
                  Resume from page {item.highestPageNumber}
                </p>
              </div>

              <div className="continue-reading-tile__footer">
                <div className="continue-reading-tile__progress">
                  <div
                    className="continue-reading-tile__progressFill"
                    style={{ width: `${item.progressPercent}%` }}
                  />
                </div>

                <p className="continue-reading-tile__percent">
                  {item.progressPercent}% read
                </p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </PortalCard>
  );
}

